import React, { useContext } from 'react';
import * as Env from 'widget/env';

interface ConvoContext {
  messageList: Env.Message[];
}

const ConvoContext = React.createContext<ConvoContext>({} as ConvoContext);

export const useConvoContext = () => useContext(ConvoContext);
export default ConvoContext;
